














import { defineComponent, ref, watch } from '@vue/composition-api';

import {
  getVisitors,
} from '@/api/index';

const CommonVisitorSelector = defineComponent({
  props: {
    modelValue: {
      default: null,
    },
    label: {},
    rules: {},
  },
  setup(props, { emit }) {
    const internalValue = ref(null);

    function result(e: any) {
      return e.data.data;
    }

    watch(() => [internalValue.value, props.modelValue], ([newValInternal, newModelValue]) => {
      if (newValInternal !== newModelValue) {
        emit('input', newValInternal);
      }
    });

    return {
      internalValue,
      result,
      getVisitors,
    };
  },
});

export default CommonVisitorSelector;
